import { Logger as g } from "@nextgen-web-framework/core";
import { logObject as u } from "@commerce-product-webcomponents/sdk";
import { LinkQueryParamsEnum as i } from "./common.js";
const p = g.getInstance(u("dynamicUrlGeneratorError")), y = (r, n) => {
  try {
    if (n) {
      const t = Object.entries(n).map(([c, e]) => `${encodeURIComponent(c)}=${encodeURIComponent(e)}`).join("&"), o = r.includes("?") ? "&" : "?";
      return r + o + t;
    }
    return r;
  } catch (t) {
    return p.error("Error in dynamic URL generator: ", t), r;
  }
}, I = (r, n, t, o) => {
  const c = {}, e = t;
  return n != null && n.includes(i.abo) && o && (c.abo_id = o), n != null && n.includes(i.lang) && e && (c.lang = e), y(r, c);
};
export {
  I as createDynamicUrl
};
//# sourceMappingURL=dynamicUrlGenerator.js.map
